module.exports = __webpack_public_path__ + "images/icons_v2/calculator-7dadb594.svg";